import { exampleUser, User } from '../user/User';
import { EventName } from '../offline-events';
import { UploadFileFormat } from './UploadFileFormat';
import { DataSource, exampleDataSource } from '../data-source/DataSource';

export type ThirdPartyDataIntegration = 'Mindbody' | 'Ringcentral';
export type ReviewStatus =
  | 'not_submitted'
  | 'submitted'
  | 'rejected'
  | 'approved';
export type ValidationStatus = 'pending' | 'valid' | 'invalid';
export type UploadStatus = 'not_submitted' | 'pending' | 'upload' | 'error';

export type FacebookAPIUploadType = 'OfflineConversionsAPI' | 'ConversionsAPI';

export interface UserUploadVersion {
  id: number;
  version: number;
  fileName: string;
  dateUploaded: string;
  userUploadID: number;
  submitted: boolean;
  submittedUser?: User;
  submittedAt?: string;
  reviewedUser?: User;
  reviewedAt?: string;
  uploaded: boolean;
  validationStatus: ValidationStatus;
  user?: User;
  uploadedUser?: User;
  approved?: boolean;
  statusMessage?: string;
  uploadStatus: UploadStatus;
  reviewStatus: ReviewStatus;
  rowCount?: number;
  errorCount?: number;
}

export interface UserUpload {
  id: number;
  displayName: string;
  eventName?: EventName;
  dataSource: DataSource;
  locked: boolean;
  flagged: boolean;
  integration?: ThirdPartyDataIntegration;
  format: UploadFileFormat;
  aggregate: boolean;
  versions: UserUploadVersion[];
  startDate: string; // ISO string
  endDate: string; // ISO string
  businessID: number;
  businessName: string;
  timezone: string;
  fbAPIUploadType: FacebookAPIUploadType;
  uploadTag?: string;
}

export const exampleUserUploadVersion: UserUploadVersion = {
  id: 1,
  version: 0,
  fileName: '',
  user: exampleUser,
  dateUploaded: '',
  userUploadID: 0,
  submitted: false,
  uploaded: false,
  uploadStatus: 'not_submitted',
  validationStatus: 'pending',
  reviewStatus: 'not_submitted',
};

export const exampleUserUpload: UserUpload = {
  id: 0,
  displayName: 'test.csv',
  dataSource: exampleDataSource,
  locked: false,
  flagged: false,
  integration: undefined,
  aggregate: false,
  format: UploadFileFormat.FacebookOfflineEvent,
  versions: [exampleUserUploadVersion],
  startDate: new Date().toISOString(),
  endDate: new Date().toISOString(),
  businessID: 1,
  businessName: 'Test Business',
  uploadTag: undefined,
  timezone: 'America/Chicago',
  fbAPIUploadType: 'OfflineConversionsAPI',
};
